import { useState, useEffect } from "react";
import NeonStage from "@/components/NeonStage";
import { Reveal } from "./Reveal";
import { scrollToId } from "./scrollTo";

const PLANS = [
  { id: "content", name: "план: Контент", option: "Контент", price: "800 €", unit: "/месец", desc: "Снимки, видео, дизайн и текстове — постоянен поток съдържание, което да публикуваш в своите канали." },
  { id: "personal", name: "план: Персонален", option: "Персонален", price: "ЛИЧНА ОФЕРТА", isCustom: true, desc: "Искаш повече от план Контент, но план Агенция ти е твърде много? Разкажи ни повече." },
  { id: "agency", name: "план: Агенция", option: "Агенция", price: "3 000 €", unit: "/месец", desc: "Всичко от план Контент, плюс стратегия (тримесечни и годишни планове), социални мрежи (Instagram, TikTok, Facebook, LinkedIn, Google), уеб дизайн и рекламни кампании. Маркетинг от А до Я." },
];

// картата, която е най-близо до средата на екрана, получава клас is-active —
// тънка ивица през средата на екрана; работи и за последната карта
function useMiddleCardHighlight() {
  useEffect(() => {
    const cards = document.querySelectorAll(".pricing .card");
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.target.classList.toggle("is-active", e.isIntersecting));
    }, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });
    cards.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, []);
}

// лъчите са само за десктоп — на телефон картите са една под друга,
// затова там изобщо не монтираме платното (и спира да работи при скрол)
function useIsPhone() {
  const [phone, setPhone] = useState(() => window.matchMedia("(max-width: 640px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    const fn = (e) => setPhone(e.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);
  return phone;
}

const PriceCard = ({ plan, onSelectPlan }) => (
  <div
    className="card group flex h-full flex-col justify-between px-[30px] pt-[34px] pb-[30px] rounded-2xl min-h-[346px] border border-white bg-transparent hover:border-[var(--red)] transition-colors [transition-duration:250ms]"
    data-testid={`price-card-${plan.id}`}
  >
    <div>
      <p className="plan-name text-[20px] font-semibold text-[var(--white)]">
        {plan.name}
      </p>
      <p
        className={`price font-display text-[var(--red)] ${plan.isCustom ? "text-[30px]" : "text-[42px]"}`}
        data-testid={`price-value-${plan.id}`}
      >
        {plan.isCustom ? plan.price : <><span>{plan.price}</span><span className="text-[17px] text-[var(--dim)]"> {plan.unit}</span></>}
      </p>
      <p className="text-[15px] leading-relaxed text-white">{plan.desc}</p>
    </div>
    <a
      href="#contact"
      onClick={(e) => { onSelectPlan?.(plan.option); scrollToId("contact")(e); }}
      className="mt-10 inline-flex w-fit items-center gap-2 rounded-full bg-[var(--red)] text-white px-6 py-3 text-[14px] font-semibold uppercase tracking-wide transition-opacity hover:opacity-90"
      data-testid={`price-cta-${plan.id}`}
    >
      {plan.isCustom ? "Поискай оферта →" : "Избери пакет →"}
    </a>
  </div>
);

export const Prices = ({ onSelectPlan }) => {
  const isPhone = useIsPhone();
  useMiddleCardHighlight();

  return (
    <section id="prices" className="pricing relative min-h-[230vh]" data-testid="prices-section">
      <div className="pin">
        {!isPhone && <NeonStage variant="rays" cardSelector=".card" />}
        <div className="relative z-[1] w-full">
          <Reveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#EE443E] mb-5">
              Цени
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2
              className="font-display uppercase text-4xl lg:text-[42px] mb-12 text-[var(--white)]"
              data-testid="prices-headline"
            >
              ИЗБЕРИ КАКВОТО<br />ТИ Е НУЖНО
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-testid="prices-grid">
            {PLANS.map((plan, i) => (
              <Reveal key={plan.id} delay={i * 0.08} className="h-full">
                <PriceCard plan={plan} onSelectPlan={onSelectPlan} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prices;
